fx.ns("filters.photofilters", class LumiereFilter extends filters.photofilters.BaseFilter {
    
    constructor(parameters)
    {
        super(parameters);

        this.amount = this.params.amount;
        
        
    };

  

	filterFCN(add)
	{
    	 add.colorMatrix('matrix', [ this.amount, 0, 0, 0, 0,
		                             0, this.amount, 0, 0, 0,
		                             0, 0, this.amount, 0, 0,
		                             0, 0, 0, 1, 0 ]);
	}
  

});
